module.exports = __webpack_public_path__ + "public/images/icons/belarus.6bccbe50b7e16ab8f43aeb5240d5a05f.png";